import { useTranslation } from 'react-i18next';
import { TranslationKeys, PostProcessKeys } from 'translations';

export enum BulkImportType {
  DATA_VENDOR = 'data_vendor',
  CONTACT = 'contact',
  DATASET = 'dataset',
  FILE = 'file',
}

export type BulkImportTypeOption = {
  label: string;
  value: BulkImportType;
};

export function useBulkImportTypeOptions() {
  const { t } = useTranslation();

  const options: BulkImportTypeOption[] = [
    {
      label: t(TranslationKeys.dataProvider_other, {
        postProcess: PostProcessKeys.TitleCase,
      }),
      value: BulkImportType.DATA_VENDOR,
    },
    {
      label: t(TranslationKeys.contact_other, {
        postProcess: PostProcessKeys.TitleCase,
      }),
      value: BulkImportType.CONTACT,
    },
    {
      label: t(TranslationKeys.dataProduct_other, {
        postProcess: PostProcessKeys.TitleCase,
      }),
      value: BulkImportType.DATASET,
    },
    {
      label: 'Files',
      value: BulkImportType.FILE,
    },
  ];

  return options;
}
